var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rkm-application',[_c('Header',{on:{"toggle":_vm.handleToggle}}),_c('Sidebar',{attrs:{"open":_vm.open}}),_c('rkm-main',{attrs:{"open":_vm.open}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }